/**
 * Canal entre os componentes gerados e o chat. O Playground registra como
 * enviar uma mensagem; as sugestões chamam sendFromComponent. Sem registro
 * (página de conversa compartilhada, só leitura) os botões ficam desativados.
 */
type SendHandler = (text: string) => void;

let sendHandler: SendHandler | null = null;

export function registerGenuiSend(handler: SendHandler | null): void {
  sendHandler = handler;
}

export function canSendFromComponent(): boolean {
  return sendHandler !== null;
}

export function sendFromComponent(text: string): boolean {
  const msg = (text || '').trim();
  if (!sendHandler || !msg) return false;
  sendHandler(msg);
  return true;
}
